<script>
import request from '@utils/request'
import vueSignature from 'vue-signature'
import { genderFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import { debounce } from 'lodash'
// base64 to FileObject
const dataURLtoFile = function(dataurl, filename) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

export default {
  filters: {
    genderFilter,
    formatDate,
  },
  components: {
    vueSignature,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      signatureOption: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'white',
      },
      tryingSignature: false,
      activeStep: 1, // 預設值就2，發票放到別的地方
      submitData: {},
      width: window.innerWidth,
      stepList: Object.freeze([
        {
          title: '填寫發票資訊',
        },
        {
          title: '簽名確認',
        },
      ]),
    }
  },
  computed: {
    isMobile() {
      return /Mobi/.test(navigator.userAgent)
    },
    vueSignatureHeight() {
      return this.width < 481 ? '500px' : '300px'
    },
  },
  mounted() {
    // 行動裝置轉向時會將canvas長寬歸零，觸發 resize 來恢復長寬
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 1000)
    window.addEventListener('resize', () => {
      this.width = window.innerWidth
    })
  },
  methods: {
    onBtnClickClearSign() {
      this.$refs.signature.clear()
    },
    onBtnClickUndoSign() {
      this.$refs.signature.undo()
    },
    handleSubmit: debounce(async function() {
      this.tryingSignature = true
      if (this.$refs.signature.isEmpty()) {
        this.$message({
          type: 'error',
          message: '請在框中簽名！',
        })
        this.tryingSignature = false
      } else {
        try {
          const signData = this.$refs.signature.save() // default format is png
          const rid = Math.floor(Math.random() * 5000000)
          await this.handleUpload(dataURLtoFile(signData, `signature_${rid}.png`))
        } catch (error) {
          console.error(error.message)
        } finally {
          this.tryingSignature = false
        }
      }
    }, 1000),
    async handleUpload(file) {
      try {
        const formData = new FormData()
        formData.append('files[]', file)
        formData.append('dir', 'signature')
        this.tryingToUpload = true
        const imgUrl = await request.post('/admin/merchant/media/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        this.$emit('updateImgUrl', imgUrl)
        this.tryingToUpload = false
        this.$emit('closeSignature')
      } catch (error) {
        console.error(error.message)
      } finally {
        this.onBtnClickClearSign()
        this.tryingSignature = false
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<template>
  <el-dialog :title="dialogTitle" :class="$style.sign" :visible="visible" :fullscreen="isMobile" top="0" append-to-body @close="handleClose">
    <template>
      <p style="">簽名確認</p>
      <div style="position: relative;">
        <div :class="$style.actions">
          <el-tooltip class="item" effect="dark" content="復原" placement="top">
            <el-button class="is-round fs-2xl p-2" type="text" @click="onBtnClickUndoSign">
              <BaseIcon name="redo"></BaseIcon>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="清除簽名" placement="top">
            <el-button class="is-round fs-2xl p-2" type="text" @click="onBtnClickClearSign">
              <BaseIcon name="trash-alt"></BaseIcon>
            </el-button>
          </el-tooltip>
        </div>
        <vueSignature ref="signature" :class="$style['signature-area']" :sig-option="signatureOption" :w="'100%'" :h="vueSignatureHeight"></vueSignature>
      </div>
      <el-row :gutter="20" style="margin-top:30px;">
        <el-col :span="24"> <el-button class="is-round w-100" type="primary" :loading="tryingSignature" :disabled="tryingSignature" @click="handleSubmit">確認</el-button></el-col>
        <el-col :span="24"><el-button class="is-round w-100 mt-3" @click="$emit('closeSignature')">取消</el-button></el-col>
      </el-row>
    </template>
  </el-dialog>
</template>
<style lang="scss" module>
@import '@design';

.signature-area {
  :global {
    canvas {
      border: 1px solid #c6c6ba;
      border-radius: 8px;
    }
  }
}

.info {
  text-align: center;

  :global {
    .service {
      font-size: 20px;
      line-height: 25px;
      font-weight: 500;
    }

    .product {
      color: $color-primary;
      font-size: 16px;
      line-height: 25px;
    }

    .booking-date {
      line-height: 28px;
      color: $color-primary;
      font-weight: 500;
    }
  }
}

.actions {
  position: absolute;
  top: 0;
  right: 10px;

  :global {
    .item {
      color: #bec4c6;

      &:hover {
        color: $color-primary;
      }
    }
  }
}

.image {
  height: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(211 211 211 / 0.2);
  margin-top: 40px;
}

.steps {
  display: flex;
  justify-content: center;
  align-items: center;

  @include touch {
    justify-content: flex-start;
  }

  :global {
    .item {
      display: flex;
      align-items: center;
      opacity: 0.3;

      &.active {
        opacity: 1;
      }

      .step {
        color: white;
        background: $color-primary;
        width: 27px;
        height: 27px;
        padding: 0;
        line-height: 25px;
        text-align: center;
        font-size: 12px;
        box-shadow: 0 0 0px 2px $color-primary;
        border: 1px solid white;
        margin-right: 8px;
      }

      .title {
      }

      & + .item {
        margin-left: 20px;
      }
    }
  }
}

.sign {
  :global {
    @include touch {
      h4 {
        margin-top: 28px !important;
      }

      h4,
      p {
        text-align: left !important;
      }

      .el-dialog__headerbtn {
        top: 41px;
        font-size: 30px;
      }
    }
  }
}
</style>
